import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import UserContext from '../context/UserContext';
import { TituloPagina } from './funciones/Funciones';
import MensajeError from './UI/MensajeError';
import MensajeGrabando from './UI/MensajeGrabando';
import usePostURL from '../hooks/usePostURL';
import styles from './Inicio.module.css';

const NoSession = () => {
  const loginContext = useContext(UserContext);
  const { isGrabando, erroresPost, postData, resetErroresPost } = usePostURL();
  const [sesionVencida, setSesionVencida] = useState(false);
  const navigate = useNavigate();

  console.log('NoSession', loginContext, sesionVencida);

  useEffect(() => {
    document.title = TituloPagina(NoSession.name);
  }, []);

  useEffect(() => {
    resetErroresPost();
  }, [resetErroresPost]);

  //console.log("NoSession", sesionVencida, loginContext);

  useEffect(() => {
    if (!sesionVencida) {
      alert('Sesión vencida');
      setSesionVencida(true);

      // Prevent transient error messages while redirecting to login
      if (loginContext.setSuppressErrors) loginContext.setSuppressErrors(true);

      // Immediately clear local session and navigate to home so the UI
      // doesn't depend on the backend responding to the logout request.
      try {
        loginContext.UsuarioDeslogueadoHandler();
      } catch {
        // ignore
      }
      navigate('/');

      // Still try to notify backend, but don't wait for it.
      try {
        postData('logout', null, () => {});
      } catch {
        // ignore
      }

      // After a short delay, allow errors again so regular pages show messages
      setTimeout(() => {
        if (loginContext.setSuppressErrors) loginContext.setSuppressErrors(false);
      }, 2000);
    }
  }, [sesionVencida, postData, loginContext, navigate]);

  return (
    <div className={`${styles.contenedor}`}>
      <React.Fragment>
        <div className={`${styles.nosession}`}>Sesión vencida</div>
      </React.Fragment>
      <MensajeGrabando estilo={`${styles.cargando}`} isCargando={isGrabando} />
      <MensajeError estilo={`${styles.error}`} errores={erroresPost} />
    </div>
  );
};

export default NoSession;
